import {setFlightData} from '../slice/flightSlice';
import {baseQueryWithReAuth} from './config';
import {IFlightDetail, IFlightItem} from '@/types/flight';
import {transformAirline} from '@/utils/flight';
import {createApi} from '@reduxjs/toolkit/query/react';
import moment from 'moment';

// interface SelectOptionRequest {
//   flight_id: string;
//   airline: string;
//   option: 'adjust_CI' | 'adjust_sequence' | 'adjust_TOBT';
//   option_result:
//     | IFlightDetail['adjust_CI']
//     | IFlightDetail['adjust_sequence']
//     | IFlightDetail['adjust_TOBT'];
// }

export const flightApi = createApi({
  reducerPath: 'flightApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ['flight-info'],
  endpoints: (builder) => ({
    getListFlight: builder.query<IFlightItem[], {airline: string}>({
      providesTags: () => ['flight-info'],
      query: ({airline}) => ({
        url: '/ATLAS_tmm__get_flights_FE',
        method: 'POST',
        body: {
          airline: transformAirline(airline)
        }
      }),
      async onQueryStarted(_args, {dispatch, queryFulfilled}) {
        try {
          const data = await queryFulfilled;

          const finalData = data.data?.map((item) => {
            // - [ ] 1st: randomzie 15000 -> 20000
            const mockCost = Math.floor(Math.random() * 5000) + 15000;
            // - [ ] 3rd: remaining flight time (eta - current time). get value  in minute + 45m
            const now = moment.utc();
            const mockFuelTime = moment
              .utc(item.dynamic_arrival_time?.time_val)
              .add(45, 'minutes')
              .diff(now, 'minutes');
            const mockPassenger = Math.floor(Math.random() * 150) + 200;
            const mockConnectingPassenger = Math.floor(Math.random() * 10) + 1;
            return {
              ...item,
              small_text: {
                ...item.small_text,
                cost_delta: item.small_text.delay * 100,
                cost: mockCost,
                fuel: Number(mockFuelTime) < 0 ? 0 : mockFuelTime,
                pax_number: mockPassenger,
                conn_pax_number: mockConnectingPassenger
              }
            };
          });
          if (finalData) {
            dispatch(setFlightData(finalData));
          }
        } catch (error) {
          throw new Error('Error getListFlight');
        }
      }
    }),
    getFlightDetail: builder.query<
      IFlightDetail,
      {
        airline: string;
        flight_number: string;
        std: string;
        sta: string;
        date: string;
      }
    >({
      query: (body) => ({
        url: '/ATLAS_tmm__get_flight_FE',
        method: 'POST',
        body: {
          airline: transformAirline(body.airline),
          flight_number: body.flight_number,
          std: body.std,
          sta: body.sta,
          date: body.date
        }
      })
    })
    // selectOption: builder.mutation<any, SelectOptionRequest>({
    //   query: (body) => ({
    //     url: '/ATLAS_tmm__select_option',
    //     method: 'POST',
    //     body
    //   }),
    //   invalidatesTags: ['flight-info']
    // })
  })
});

export const {
  useGetListFlightQuery,
  useLazyGetListFlightQuery,
  useLazyGetFlightDetailQuery
  // useSelectOptionMutation
} = flightApi;
